module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/routes/firms/firms-index/firms-index.component.css
// module id = ./src/app/routes/firms/firms-index/firms-index.component.css
// module chunks = 9